import nextAll from "./nextAll.js";

export default (elem, selector) => nextAll(elem, selector)[0];
